module.exports = __webpack_public_path__ + "img/security2-logo32.084b293b.png";